import { _loanApplicationStore } from './loan-application/loan-application-store';

export const loanApplicationStore = () => {
  const { setActiveApplicationId, activeApplicationId } =
    _loanApplicationStore.getState();

  return {
    setActiveApplicationId,
    activeApplicationId,
  };
};
